/**
 * Single-select adapter for MultiSelect's toggle semantics.
 *
 * MultiSelect's toggleOption appends the newly clicked option to the END of
 * the value array (onChange([...value, clicked])). Handlers that emulate a
 * single-select with value={[current]} must adopt the last element — the
 * newly clicked option — not values[0], which is the previous selection.
 *
 * Returns undefined when the array is empty (the user deselected the current
 * option); callers decide the fallback (e.g. 'ALL').
 */
export function lastSelectedValue(values: string[]): string | undefined {
  return values.length > 0 ? values[values.length - 1] : undefined;
}
